import { useRef } from "react";
import { useTranslation } from "react-i18next";
import config from "../../../../config.json";
import { MENU_CONTENT_TYPES } from "../../../constants/menuContentType";

export default function MenuContentTypeSection({
  menuContentType,
  staticMenuMediaType,
  staticMenuFile,
  staticFilePreview,
  onMenuContentTypeChange,
  onStaticFileSelect,
  onRemoveStaticFile,
}) {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const isStatic = menuContentType === MENU_CONTENT_TYPES.STATIC;

  const previewUrl =
    staticFilePreview ||
    (staticMenuFile
      ? `${config.UPLOADS_SERVER}/menu/${staticMenuFile}`
      : null);

  return (
    <div className="menu-content-type-section mb-4">
      <div className="menu-form-field-label">{t("menuContentTypeLabel")}</div>
      <p className="menu-form-field-hint mb-3">{t("menuContentTypeHint")}</p>

      <div className="menu-content-type-options">
        <label className="menu-content-type-option">
          <input
            type="radio"
            name="menuContentType"
            value={MENU_CONTENT_TYPES.INTERACTIVE}
            checked={!isStatic}
            onChange={() => onMenuContentTypeChange(MENU_CONTENT_TYPES.INTERACTIVE)}
          />
          <span>{t("menuContentTypeInteractive")}</span>
        </label>
        <label className="menu-content-type-option">
          <input
            type="radio"
            name="menuContentType"
            value={MENU_CONTENT_TYPES.STATIC}
            checked={isStatic}
            onChange={() => onMenuContentTypeChange(MENU_CONTENT_TYPES.STATIC)}
          />
          <span>{t("menuContentTypeStatic")}</span>
        </label>
      </div>

      {isStatic ? (
        <div className="menu-static-upload mt-3">
          <p className="menu-form-field-hint mb-2">{t("menuStaticFileHint")}</p>

          {previewUrl ? (
            <div className="menu-static-upload__preview">
              {staticMenuMediaType === "pdf" &&
              !staticFilePreview &&
              staticMenuFile ? (
                <div className="menu-static-upload__pdf-badge">
                  <i className="fa fa-file-pdf me-2" />
                  {staticMenuFile}
                </div>
              ) : staticMenuMediaType === "pdf" && staticFilePreview ? (
                <iframe
                  title={t("menuContentTypeStatic")}
                  src={previewUrl}
                  className="menu-static-upload__pdf-preview"
                />
              ) : (
                <img src={previewUrl} alt="" className="menu-static-upload__image" />
              )}
              <div className="d-flex gap-2 mt-2 flex-wrap">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => fileInputRef.current?.click()}
                >
                  {t("change")}
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={onRemoveStaticFile}
                >
                  {t("remove")}
                </button>
              </div>
            </div>
          ) : (
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={() => fileInputRef.current?.click()}
            >
              <i className="fa fa-upload me-1" />
              {t("menuStaticUploadButton")}
            </button>
          )}

          <input
            ref={fileInputRef}
            type="file"
            hidden
            accept="image/jpeg,image/png,image/webp,image/gif,application/pdf"
            onChange={onStaticFileSelect}
          />
        </div>
      ) : null}
    </div>
  );
}
